import CustomerLogo from './CustomerLogo';
import ProfileComponents from './ProfileComponents';

export default { ProfileComponents, CustomerLogo };
